import { Action } from '@reduxjs/toolkit';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { Dispatch } from 'redux';

import { get } from '@eika-infrastruktur/request';
import { Loader } from '@eika/loader';

import { useKunde } from '../kundeinfo/kunde-context';
import { SkadeWebDTO } from '../types/generated-types';
import { getSkaderUrl } from '../urler';
import { EttersendingForm } from './form/ettersending-form';
import { setSkadenummer, setSkadesakExists } from './reducer/ettersending-actions';

const getSkadenummerFromQueryParam = (queryParameters: string): string | undefined => {
    const urlParams = new URLSearchParams(queryParameters);
    return urlParams.get('skadenummer');
};

const getSkader = async (kundenummer: string, offentligId: string): Promise<SkadeWebDTO[]> =>
    get<SkadeWebDTO[]>(getSkaderUrl(kundenummer, offentligId));

const Ettersending: FC = () => {
    const dispatch: Dispatch<Action> = useDispatch();
    const { getKundeinfo, kundeinfo } = useKunde();
    const location = useLocation();
    const skadenummerFromQueryParam = getSkadenummerFromQueryParam(location.search);
    const [isFetchingKundeAndSkader, setIsFetchingKundeAndSkader] = useState<boolean>(true);
    const [skader, setSkader] = useState<SkadeWebDTO[]>([]);

    useEffect(() => {
        if (!kundeinfo) {
            getKundeinfo()
                .then(() => {
                    if (skadenummerFromQueryParam) setIsFetchingKundeAndSkader(false);
                })
                .catch(() => setIsFetchingKundeAndSkader(false));
        }
    }, [dispatch, getKundeinfo, kundeinfo, skadenummerFromQueryParam]);

    useEffect(() => {
        if (!skadenummerFromQueryParam && kundeinfo) {
            getSkader(kundeinfo.kundenummer, kundeinfo.offentligId)
                .then((skader) => setSkader(skader))
                .finally(() => {
                    setIsFetchingKundeAndSkader(false);
                });
        }
    }, [dispatch, getKundeinfo, kundeinfo, skadenummerFromQueryParam]);

    useEffect(() => {
        if (skadenummerFromQueryParam) {
            dispatch(setSkadenummer(skadenummerFromQueryParam));
            dispatch(setSkadesakExists(true));
        }
    }, [skadenummerFromQueryParam, dispatch]);

    if (isFetchingKundeAndSkader) {
        return <Loader />;
    }

    return <EttersendingForm skadenummerFromQueryParam={skadenummerFromQueryParam} skader={skader} />;
};

export default Ettersending;
